import { Inject } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { NXDataSourcePrime } from '../../services/dataSource/NXDataSourcePrime';
import { TimeEntryCategory } from '../../entities/timeEntryCategory/timeEntryCategory';
import * as fromGraphQl from './graphql';

export class TimeEntryCategoryDataSource extends NXDataSourcePrime<TimeEntryCategory> {
  constructor(
    apollo: Apollo,
    @Inject('env') environment : any
    ) {
    super(apollo, fromGraphQl.TIME_ENTRY_CATEGORIES_QUERY, environment);
  }
  handleSubscriptionResult(data: fromGraphQl.TimeEntryCategoriesQueryResponse): void {
    super.setSubject(
      data.timeEntryCategories?.content ? TimeEntryCategory.createTimeCategoryEntries(data.timeEntryCategories?.content) : [],
      data.timeEntryCategories?.totalElements ? data.timeEntryCategories.totalElements : 0
    );
  }

  loadTimeEntryCategories(variables: any): void {
    this.querySubscription?.unsubscribe();
    this.subscribeToQuery(variables);
  }
}
